// Ekran 06 — KPI şeridi (div.kstrip · 5 × div.k).
//
// Beş gösterge ve sıraları ref_files/btys-erp-06-uretim-beyani.html:395-401'den
// birebir: Toplam Üretim · Toplam İç İhtiyaç · Toplam Satış · Dengesizlik ± ·
// Ort. Metan. "Gün" ve "Eksik / Eşik Dışı" burada DEĞİL: gün durumu başlıktaki
// rozete, eksik sayısı sekme piplerine ait (K30).

import { tr } from '../../lib/trFormat'
import type { BeyanGunuDto } from './api'
import {
  enKotuBant, gazSatiri, ortalama, tesisSatiri, tesisToplam, toplaBos,
} from './hesap'

export default function KpiSeridi({ gun }: { gun: BeyanGunuDto }) {
  const uretim = tesisToplam(gun, 'uretim')
  const ic = tesisToplam(gun, 'ic_ihtiyac')
  const satis = tesisToplam(gun, 'satis')
  const gazTuketim = tesisToplam(gun, 'gaz_tuketim')
  const uniteUretim = tesisSatiri(gun, 'uretim')?.uniteToplami ?? null

  // Üretimin payı: üretim yoksa yüzde tanımsız — "%0" yazmak yanıltıcı olurdu.
  const icPay = uretim ? ((ic ?? 0) / uretim) * 100 : null

  const deng = toplaBos(gun.dengesizlik)
  const dengPct = deng !== null && uretim ? (Math.abs(deng) / Math.abs(uretim)) * 100 : null
  // Bant sunucudan (ayar_esik) geliyor; gün kartı saatlerin en kötüsünü gösterir.
  const dengBant = enKotuBant(gun.dengesizlikBant)

  const ch4Ort = ortalama(gazSatiri(gun, 'CH₄'))

  return (
    <div className="kstrip">
      <div className="k">
        <div className="k-l">Toplam Üretim</div>
        <div className="k-v">{tr(uretim, 0)}</div>
        <div className="k-s">kWh · bağımsız beyan — ünite Σ {tr(uniteUretim, 0)}</div>
      </div>

      <div className="k">
        <div className="k-l">Toplam İç İhtiyaç</div>
        <div className="k-v">{tr(ic, 0)}</div>
        <div className="k-s">
          {icPay === null ? 'kWh · üretim beyanı yok' : `kWh · üretimin %${tr(icPay, 1)}`}
        </div>
      </div>

      <div className="k">
        <div className="k-l">Toplam Satış</div>
        <div className="k-v">{tr(satis, 0)}</div>
        <div className="k-s">kWh · şalt sayacı (ST-1)</div>
      </div>

      <div className="k">
        <div className="k-l">Dengesizlik ±</div>
        <div className={dengBant === 'kritik' ? 'k-v red' : dengBant === 'izle' ? 'k-v amber' : 'k-v'}>
          {deng !== null && deng > 0 ? '+' : ''}{tr(deng, 0)}
        </div>
        <div className="k-s">
          {dengPct === null
            ? 'kWh · (üretim − iç) − satış (K29)'
            : `kWh · %${tr(dengPct, 1)} ${(deng ?? 0) >= 0 ? 'fazla' : 'eksik'} — (üretim − iç) − satış`}
        </div>
      </div>

      <div className="k">
        <div className="k-l">Ort. Metan</div>
        <div className="k-v">{tr(ch4Ort, 1)}</div>
        <div className="k-s">% CH₄ · gaz tüketimi {tr(gazTuketim, 0)} Nm³</div>
      </div>
    </div>
  )
}
